<template>
  <b-container fluid>
    <b-row>
      <b-col id="reportConsoleLeftSide" lg="4" md="4" sm="12">
        <iq-card
          class-name="iq-card-block iq-card-stretch"
          body-class=""
          class="p-3"
          id="quickQuotePage"
        >
          <div class="row justify-content-left selectableCard mt-3">
            <div class="invalid-feedback col-sm-12" v-if="errors.reportId">
              {{ errors.reportId[0] }}
            </div>
            <div class="col-sm-6 mt-3">
              <div
                class="card text-center"
                @click="fnSelectReport(3)"
                :class="{ active: reportId == 3 }"
              >
                <div class="card-body">
                  <div class="fs-4000"><i class="lar la-file-image"></i></div>
                  <h4 class="card-text fw-500">Dealership Income Report</h4>
                </div>
              </div>
            </div>
          </div>

          <b-row>
            <b-col lg="12" md="12" sm="12">
              <div class="d-flex">
                <div class="pr-2">
                  <label class="" for="noteOnOtherIncome">From date</label>
                  <datePicker
                    :editable="true"
                    value-type="YYYY-MM-DD"
                    format="DD-MM-YYYY"
                    placeholder="DD-MM-YYYY"
                    v-model="fromDate"
                  >
                  </datePicker>
                  <div class="invalid-feedback" v-if="errors.fromDate">
                    {{ errors.fromDate[0] }}
                  </div>
                </div>
                <div class="pl-2">
                  <label class="" for="noteOnOtherIncome">To date</label>
                  <datePicker
                    :editable="true"
                    value-type="YYYY-MM-DD"
                    format="DD-MM-YYYY"
                    placeholder="DD-MM-YYYY"
                    v-model="toDate"
                  >
                  </datePicker>
                  <div class="invalid-feedback" v-if="errors.toDate">
                    {{ errors.toDate[0] }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-12 text-right mt-3">
              <button class="btn btn-primary btn-sm mr-2" @click="fnGenerate()">
                Generate
              </button>
              <button
                class="btn btn-success btn-sm"
                v-if="rptData.length > 0"
                @click="fnPrintCall()"
              >
                Print
              </button>
            </div>
          </div>
        </iq-card>
      </b-col>

      <b-col id="reportConsoleRightSide" lg="8" md="8" sm="12">
        <div>
          <div v-if="reportId == 3 && rptData.length > 0">
            <appDealerShipIncomeReport
              :prosData="rptData"
              :propsFromDate="fromDate"
              :propsToDate="toDate"
              ref="reportDealerShipIncomeReport"
            ></appDealerShipIncomeReport>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import datePicker from 'vue2-datepicker'
import appDealerShipIncomeReport from '../../../components/admin/reports/DealerShipIncomeReport.vue'
import * as reportService from '../../../services/report.service'
import * as messageService from '../../../services/message.service'
import * as authService from '../../../services/auth.service'

export default {
  name: 'Report',
  components: {
    datePicker,
    appDealerShipIncomeReport
  },
  mounted() {},
  data() {
    return {
      errors: {},
      userObj: {},
      dealers: [],
      reportId: 3,
      rptData: [],
      fromDate: '',
      toDate: ''
    }
  },
  methods: {
    fnSelectReport(reportId) {
      this.rptData = []
      this.reportId = reportId
    },
    async fnGenerate() {
      let dataObj = {
        reportId: this.reportId,
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      try {
        this.errors = {}
        const res = await reportService.dealerGetAllSettled(
          this.userObj.id,
          dataObj
        )
        this.rptData = res.data

        localStorage.setItem('dataObj', JSON.stringify(dataObj))
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              'Something wrong'
            )
            break
        }
      }
    },
    fnPrintCall() {
      if (this.reportId == 3) {
        const routeData = this.$router.resolve({
          name: 'DealerShipIncomeReportPrintDealer'
        })
        window.open(routeData.href, '_blank')
      }
    }
  },
  created() {
    this.userObj = authService.getUserFromToken()
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
</style>
